export const CURRENT_VERSION = '2.0.0';

export interface VersionInfo {
    version: string;
    date: string;
    changes: string[];
}

export const CHANGELOG: VersionInfo[] = [
    {
        version: '2.0.0',
        date: 'Noviembre 2025',
        changes: [
            '¡NUEVO! Historial de versiones para mantenerte al día de las novedades.',
            'Refactorización interna para mejorar la velocidad y la capacidad de respuesta de la aplicación.',
            'Mejoras generales en la interfaz y la experiencia de usuario.'
        ]
    },
    {
        version: '1.8.0',
        date: 'Septiembre 2025',
        changes: [
            'Introducción de planes de suscripción (Mensual, Anual, Bianual) y una prueba gratuita de 30 días.',
            'Implementado el portal de cliente para gestionar la suscripción y la facturación.',
            'Añadida la opción para solicitar la eliminación de la cuenta y los datos del usuario.'
        ]
    },
     {
        version: '1.6.0',
        date: 'Junio 2025',
        changes: [
            '¡NUEVO! Prorrateo de Gastos en Configuración para distribuir gastos compartidos.',
            'Implementado un Tour Guiado interactivo para dar la bienvenida a los nuevos usuarios.',
            'Mejorada la gestión de acciones en bloque en la vista de transacciones.'
        ]
    },
    {
        version: '1.4.0',
        date: 'Febrero 2025',
        changes: [
            '¡Revolución IA! Añadido el registro de transacciones por voz.',
            'Mejorado el motor de IA para la categorización automática y la creación de reglas inteligentes.',
            'Añadido el Centro de Ayuda con asistente conversacional y preguntas frecuentes.'
        ]
    },
    {
        version: '1.2.0',
        date: 'Octubre 2024',
        changes: [
            'Añadida la sección de Registro de Horas con cronómetro y temporizador.',
            'Implementada la vista de Análisis Mensual con gráficos de evolución financiera.',
            'Mejoras de rendimiento en la importación de archivos Excel.'
        ]
    },
    {
        version: '1.0.0',
        date: 'Junio 2024',
        changes: [
            'Lanzamiento inicial de Mis Cuentas 360.',
            'Funcionalidades básicas: Panel, gestión de transacciones y categorías.',
            'Soporte para temas claro y oscuro.'
        ]
    }
];
